import * as React from 'react'
import { Link } from 'react-router-dom'
import { IAssistanceCategoryObject, IAssistanceObject } from '../../types/index'
import EditIcon from '../icons/ui/Edit'
import Trash from '../icons/ui/Trash'
import ContextMenu from '../ui/ContextMenu'

export interface IAssistanceListItemProps {
  assistance: IAssistanceObject
  category: IAssistanceCategoryObject
  onRemove: (assistance: IAssistanceObject) => void
}

const AssistanceListItem = ({ assistance, category, onRemove }: IAssistanceListItemProps) => {
  const toRemove = () => {
    onRemove(assistance)
  }

  return (
    <div className='mb3'>
      <div className='flex pl3'>
        <div className='col-3'>
          <span className='AssistanceListItemCategory'>{category.name}</span>
        </div>
        <div className='col-3'>
          <span className='AssistanceListItemName'>{assistance.type}</span>
        </div>
        <div className='col-3'>
          <span>{assistance.instruction}</span>
        </div>
        <div className='col-3'>
          <div className='ml3'>
            <ContextMenu>
              <div className='MenuItem flex cursor--pointer'>
                <Link to={`/assistance/edit-assistance/${assistance.id}`}>
                  <EditIcon className='icon--small svg-stroke-grey3 mr1' />
                  <span className='font-dark-grey'>Edit</span>
                </Link>
              </div>
              <div className='MenuItem flex cursor--pointer'>
                <div onClick={toRemove}>
                  <Trash className='icon--small svg-stroke-grey3 mr1' />
                  <span className='font-dark-grey'>Remove</span>
                </div>
              </div>
            </ContextMenu>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AssistanceListItem



// WEBPACK FOOTER //
// ./src/components/assistance/AssistanceListItem.tsx